import $ from "jquery";
import wrapper from "flow/promise/promiseWrapper";
import MyFlow from "flow/MyFlow";

// eslint-disable-next-line @typescript-eslint/naming-convention
export interface JQueryDeferredPlus<T> extends JQueryDeferred<T> {
    promiseWithoutTask(): JQueryPromise<T>;
}

export default function deferred<T>(myFlow: MyFlow, func?: () => void): JQueryDeferredPlus<T> {
    let dfd: JQueryDeferred<T>;
    if (func) {
        dfd = $.Deferred(func);
    } else {
        dfd = $.Deferred();
    }

    let wrappedPromise: JQueryPromise<T> = null;

    const promise = dfd.promise;

    dfd.promise = function (target?: any) {
        if (wrappedPromise === null) {
            wrappedPromise = wrapper.wrap(myFlow, promise(target));
            myFlow.addTask(wrappedPromise);
        }
        return wrappedPromise;
    };

    (dfd as any).promiseWithoutTask = function (target?: any) {
        if (wrappedPromise === null) {
            wrappedPromise = wrapper.wrap(myFlow, promise(target));
        }
        return wrappedPromise;
    };

    return dfd as JQueryDeferredPlus<T>;
}
